import React from "react";

export default function LoadingScreen({
  variant = "loading", // loading | error
  title,
  message = "در حال بارگذاری...",
  onRetry,
}) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: 24,
        textAlign: "center",
        background: "var(--bg)",
        color: "var(--ink)",
      }}
    >
      {variant === "loading" ? (
        <div className="spinner" />
      ) : (
        <div style={{ fontSize: 44, lineHeight: 1, color: "var(--muted)" }}>
          <i
            className={`fa-solid ${
              navigator.onLine === false ? "fa-wifi" : "fa-triangle-exclamation"
            }`}
          />
        </div>
      )}
      {title && <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{title}</h2>}
      <p style={{ margin: 0, color: "var(--muted)", fontSize: 14 }}>{message}</p>
      {variant === "error" && onRetry && (
        <button className="btn" style={{ padding: "11px 22px" }} onClick={onRetry}>
          تلاش دوباره
        </button>
      )}
    </div>
  );
}
